<template>
    <div :class="['app', { 'is-head': isHead }]">
        <yx-head v-if="isHead"></yx-head>
        <el-config-provider :locale="locale">
            <router-view />
        </el-config-provider>
    </div>
</template>
<script>
import { ElConfigProvider } from 'element-plus'
import head from '@/components/head/index.vue'
import zhCn from 'element-plus/lib/locale/lang/zh-cn';

export default {
    components: {
        'yx-head': head,
        [ElConfigProvider.name]: ElConfigProvider,
    },
    data() {
        return {
            isHead: false,
            locale: zhCn
        }
    },
    mounted() {
        this.isHead = this.$route.meta.auth;
    },
    watch: {
        $route(to) {
            this.isHead = to.meta.auth;
        }
    }
}
</script>
<style lang="scss">
    @import "@/assets/css/base.scss";

    .app {
        &.is-head {
            padding-top: 60px;
        }
    }

    .container {
        width: 80%;
        margin: 0 auto;
    }

    .page {
        text-align: right;
        margin-top: 10px;
    }
</style>
